class SizeChart extends HTMLElement {
  constructor() {
    super()
    this.tabs = this.querySelectorAll('.size-chart-tab')
    this.contents = this.querySelectorAll('.size-chart-content')
    this.spinner = this.querySelector('.Page-Size-Chart__Loading')
    this.handleTabClick = this.handleTabClick.bind(this)
    this.initTabs()
  }

  initTabs() {
    if (this.tabs.length > 0) {
      let startTab = this.tabs[0]
      if (this.dataset.initialTab) {
        const match = Array.from(this.tabs).find((tab) => tab.dataset.table === this.dataset.initialTab)
        if (match) startTab = match
      }

      const startContent = this.querySelector(`.size-chart-content[data-id="${startTab.dataset.id}"]`)
      if (startTab !== this.tabs[0] && startContent) {
        this.setActiveTab(startTab, startContent)
      }

      if (startContent && startContent.dataset.static !== 'true') {
        this.loadTabContent(startTab.dataset.table, startContent)
      }

      this.hideSpinner()
      this.tabs.forEach(tab => {
        tab.addEventListener('click', this.handleTabClick)
        tab.addEventListener('keydown', this.handleTabKeyDown.bind(this))
      })
    }
  }

  async handleTabKeyDown(event) {
    const currentIdx = Array.from(this.tabs).indexOf(event.currentTarget)
    let nextIdx = currentIdx
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault()
      nextIdx = Math.min(currentIdx + 1, this.tabs.length - 1)
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault()
      nextIdx = Math.max(currentIdx - 1, 0)
    }
    if (nextIdx !== currentIdx) {
      await this.activateTab(this.tabs[nextIdx])
      this.tabs[nextIdx].focus()
    }
  }

  handleTabClick(event) {
    this.activateTab(event.currentTarget)
  }

  async activateTab(tab) {
    const content = this.querySelector(`.size-chart-content[data-id="${tab.dataset.id}"]`)

    if (content.dataset.loaded || content.dataset.static === 'true') {
      content.dataset.loaded = 'true'
      this.setActiveTab(tab, content)
      return
    }

    this.showSpinner()

    this.contents.forEach(c => {
      if (c.dataset.static === 'true') return
      c.innerHTML = ''
      c.removeAttribute('data-loaded')
    })

    this.setActiveTab(tab, content)
    await this.loadTabContent(tab.dataset.table, content)

    this.hideSpinner()
  }

  async loadTabContent(pageHandle, contentElement) {
    try {
      const response = await fetch(`/pages/${pageHandle}?view=size-chart`)
      if (response.ok) {
        const html = await response.text()
        const table = new DOMParser().parseFromString(html, 'text/html').querySelector('#MainContent .rte table')

        if (table) {
          contentElement.innerHTML = table.outerHTML
        } else {
          contentElement.innerHTML = '<p>No size chart available for this tab.</p>'
        }

        contentElement.dataset.loaded = 'true'
      } else {
        contentElement.innerHTML = '<p>Error loading size chart. Please try again later.</p>'
      }
    } catch (error) {
      console.error('Error fetching size chart:', error)
      contentElement.innerHTML = '<p>Error loading size chart. Please try again later.</p>'
    }
  }

  setActiveTab(tab, content) {
    this.tabs.forEach((t, i) => {
      t.classList.remove('is-active')
      t.setAttribute('aria-selected', 'false')
      t.setAttribute('tabindex', '-1')
    })
    this.contents.forEach(c => {
      c.classList.remove('is-active')
      c.hidden = true
    })

    tab.classList.add('is-active')
    tab.setAttribute('aria-selected', 'true')
    tab.setAttribute('tabindex', '0')
    content.classList.add('is-active')
    content.hidden = false
  }

  showSpinner() {
    if (this.spinner) {
      this.spinner.classList.add('is-active')
    }
  }

  hideSpinner() {
    if (this.spinner) {
      this.spinner.classList.remove('is-active')
    }
  }
}

customElements.define('size-chart', SizeChart)
